// Summary of Reach And Frequency
export const getReachAndFrequencySummaryUrl =
  "/api/v3/mavin/reach_frequency/progression";
